// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useState } from 'react';
// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const [user, setUser] = useState(localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):null);
 const navGroups = menuItem.items
  .map(item => {
    const filteredChildren = item.children?.filter(child =>
      child.permission?.some(p => user && user.permissions && user.permissions.includes(p))
    );

    return {
      ...item,
      children: filteredChildren
    };
  })
  .filter(item => item.children && item.children.length > 0).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
console.log(navGroups);

  return <Box sx={{ pt: 2 }}>{navGroups[0]}</Box>;
}
